import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import awardIcon from "../../assets/images/AwardIcon.png";
import { todoTypes } from "../../constants/index";
import DefaultPolicyIcon from "../Icons/DefaultPolicyIcon";
import clsx from "clsx";
import DefaultAnnouncementIcon from "../Icons/DefaultAnnouncementIcon";
import { Chip, Typography, Box } from "@mui/material";
import messagePic from "../../assets/images/default_message_pic.png";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  awardIcon: {
    top: 4,
    left: 8,
    width: 24,
    height: 24,
    position: "absolute"
  },
  image: {
    width: ({ width }) => width,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  policy: {
    backgroundColor: theme.palette.secondary.A400
  },
  announcement: {
    backgroundColor: theme.palette.primary.light
  }
}));

const useNewTodoBadgeStyles = makeStyles(theme => ({
  newTodoBadge: {
    position: "absolute",
    top: 4,
    left: -16
  }
}));

const NewTodoBadge = () => {
  const classes = useNewTodoBadgeStyles();
  const { t } = useTranslation();
  return (
    <Chip
      className={classes.newTodoBadge}
      color="primary"
      size="small"
      label={<Typography variant="overline">{t("New")}</Typography>}
    />
  );
};

function DefaultTodoImage(props) {
  switch (props.todoType) {
    case todoTypes.announcement:
      return <DefaultAnnouncementIcon />;
    case todoTypes.message:
      return <img src={messagePic} alt="" className={props.className} />;
    case todoTypes.policy:
      return <DefaultPolicyIcon />;
    case todoTypes.assignment:
      return null;
    default:
      return null;
  }
}

export default function TodoItemImage(props) {
  const { showAwardIncentive, title, imageSrc, todoType, isNew, width } = props;
  const classes = useStyles({ width });
  return (
    <Box position="relative">
      {showAwardIncentive && (
        <img src={awardIcon} className={classes.awardIcon} alt={"Earn Award"} />
      )}
      {imageSrc ? (
        <img src={imageSrc} alt={title} className={classes.image} />
      ) : (
        <div
          className={clsx(classes.image, {
            [classes.policy]: todoType === todoTypes.policy,
            [classes.announcement]: todoType === todoTypes.announcement
          })}
        >
          <DefaultTodoImage
            todoType={props.todoType}
            className={classes.image}
          />
        </div>
      )}
      {isNew && <NewTodoBadge />}
    </Box>
  );
}

TodoItemImage.defaultProps = {
  width: 72
};
